import { Stack, Typography } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Stack gap={1}>
      <Typography fontWeight={600}>{"Terms and Conditions"}</Typography>

      <Typography fontStyle="italic">
        {"Patient has agreed to terms and conditions: Version 1"}
      </Typography>
    </Stack>
  );
};

export default TermsAndConditions;
